var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loginWrap"},[_c('div',{staticClass:"loginWrap_image"},[_c('div',{staticClass:"loginWrap_logo"},[_c('a',{attrs:{"href":_vm.$page.props.home_url ?? '/'}},[_c(_setup.IconLogo)],1)]),_vm._v(" "),_c('img',{attrs:{"src":"/vendor/auth/images/login.png","alt":""}})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }